module.exports = __webpack_public_path__ + "fonts/opensans-semibold.0cb47871.woff";